/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'down-arrow': {
    width: 120,
    height: 120,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M966.065 264.14a58.916 58.916 0 013.446 79.567l-3.446 3.741-412.411 412.411a58.916 58.916 0 01-79.566 3.447l-3.742-3.447-412.41-412.411a58.916 58.916 0 0179.565-86.754l3.741 3.447L512 634.84l370.758-370.7a58.916 58.916 0 0179.565-3.446l3.742 3.447z"/>'
  }
})
